import styled from "styled-components";
import Hero from "src/components/Hero/Hero";
import { Row, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import ResponsiveImage from "src/components/ImageWrapper/ResponsiveImage";
import SubTitleSection from "src/components/SubTitleSection/SubTitleSection";
import EventFinished from "src/components/EventFinished";
import useResponsiveImageUrl from "src/utils/useResponsiveImageUrl";
import ReactMarkdown from "react-markdown";
import AddToCalendar from "src/components/AddToCalendar/AddToCalendar";
import AddToCalendarBanner from "src/components/AddToCalendarBanner/AddToCalendarBanner";
import Button from "src/components/Button/Button";
import { FaCalendarPlus } from "react-icons/fa";

const SaintPatricksDay2026 = () => {
  const { t, i18n } = useTranslation();

  return (
    <Div>
      <Hero
        bgImage="promotions/gaming-machines/saint-patricks-day-2026/Saint-Patricks-Day-2026-header-hero-image-2400x800px.jpg"
        buttonSettings={null}
        image={`promotions/gaming-machines/saint-patricks-day-2026/Saint-Patricks-Day-2026-logo-2400x2400px-${i18n.language}.png`}
        title={t("saintPatricksDay2026.title")}
      ></Hero>
      <EventFinished
        scheduleKeyName="saintPatricksDay2026"
        eventType="promotion"
      />
      <MainContentDiv
        bgImage={useResponsiveImageUrl(
          "promotions/gaming-machines/saint-patricks-day-2026/Saint-Patricks-Day-2026-homepage-carousel-1368x1200px-EN.jpg",
        )}
      >
        <container-div>
          <Row className="g-4 mb-5 align-items-center row-mobile-mb" id="">
            <Col xs={12} md={6}>
              <ResponsiveImage
                src="promotions/gaming-machines/saint-patricks-day-2026/Saint-Patricks-Day--2026-lp-secondary-2400x1600px-1.jpg"
                alt={t("saintPatricksDay2026.row1.title")}
              />
            </Col>
            <Col xs={12} md={6}>
              <SubTitleSection
                subTitle={t("saintPatricksDay2026.row1.title")}
                text={t("saintPatricksDay2026.row1.text")}
                borderColor="#D79215"
              />
              <AddToCalendar
                name={t("saintPatricksDay2026.calendar.name")}
                description={t("saintPatricksDay2026.calendar.description")}
                location={t("saintPatricksDay2026.calendar.location")}
                startDate="2026-03-17"
                endDate="2026-03-17"
                startTime="14:00"
                endTime="20:00"
                timeZone="America/New_York"
              >
                <Button
                  label={
                    <>
                      <FaCalendarPlus style={{ marginRight: '0.5rem' }} />
                      {t("saintPatricksDay2026.calendar.buttonLabel")}
                    </>
                  }
                  bgColor="var(--red)"
                  hoverBgColor="white"
                />
              </AddToCalendar>
            </Col>
          </Row>
          <Row
            className="g-4 mb-5 align-items-center row-mobile-mb"
            id="secondary-row"
          >
            <Col xs={12} md={6} className="order-1 order-md-2">
              <ResponsiveImage
                src="promotions/gaming-machines/saint-patricks-day-2026/Saint-Patricks-Day--2026-lp-secondary-2400x1600px-2.jpg"
                alt={t("saintPatricksDay2026.row2.title")}
              />
            </Col>
            <Col xs={12} md={6} className="order-2 order-md-1">
              <SubTitleSection
                subTitle={t("saintPatricksDay2026.row2.title")}
                text={t("saintPatricksDay2026.row2.text")}
                borderColor="#D79215"
              />
            </Col>
          </Row>
          <Row
            className="g-4 mb-4 mt-0 p-0 align-items-center row-mobile-mb smallprint-row"
          >
            <Col xs={12} className="m-0 p-0">
              <ReactMarkdown>
                {t("saintPatricksDay2026.smallPrint")}
              </ReactMarkdown>
            </Col>
          </Row>
          <AddToCalendarBanner
            bgImage={useResponsiveImageUrl(
              "promotions/gaming-machines/saint-patricks-day-2026/Saint-Patricks-Day-2026-homepage-carousel-1368x1200px-EN.jpg",
            )}
            text={t("saintPatricksDay2026.banner.text")}
            name={t("saintPatricksDay2026.calendar.name")}
            description={t("saintPatricksDay2026.calendar.description")}
            location={t("saintPatricksDay2026.calendar.location")}
            startDate="2026-03-17"
            endDate="2026-03-17"
            startTime="14:00"
            endTime="20:00"
            timeZone="America/New_York"
            gradientStart="#c2630f"
            gradientEnd="rgba(215, 146, 21, 1)"
            innerBgColor="#0d3d0d"
            overlayOpacity={0.9}
            bgPosition="top"
            bgAttachment="scroll"
          />
        </container-div>
      </MainContentDiv>
    </Div>
  );
};

const Div = styled.div`
  width: 100%;
  height: auto;
  .title-section {
    p {
      padding: 0;
      font-size: 20px;
    }
  }
  .hero_text_container {
    /* display: none; */
    h1 {
      max-width: 900px;
    }
  }
  .hero_image_container {
    padding: 20px;
  }
  .subtitle-section {
    h2 {
      font-size: 1.8rem;
    }
  }
  strong {
    color: #d79215;
  }
`;

const MainContentDiv = styled.div`
  /* background: ${(props) => `url(${props.bgImage})`}; */
  background-color: var(--lightblack);
  background-position: top;
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-size: cover;
  container-div {
    background: rgba(0, 0, 0, 0.5);
  }
  @media (min-width: 992px) {
    padding: 3rem 0;
  }
  height: auto;
  width: 100%;
  color: var(--white);
  text-align: left;
  .row {
    display: flex;
    justify-content: space-between;
    max-width: 1200px;
    margin: 0 auto;
    position: relative;
    &:nth-child(3),
    &:nth-child(5) {
      flex-direction: row-reverse;
    }
    .col-12 {
      .subtitle-section {
        @media (min-width: 768px) {
          padding-top: 0;
        }
      }
    }
  }
  .row-mobile-mb {
    @media (max-width: 767.98px) {
      margin-bottom: 1.5rem !important;
    }
  }
  .smallprint-row {
    font-style: italic;
  }
`;

export default SaintPatricksDay2026;
